import { Hash } from "lucide-react";
import type React from "react";
import type { DataFieldNumber } from "schema/agent";
import { Field } from "./Field";

export interface NumberFieldProps {
  field: DataFieldNumber;
  onChange: (value: number) => void;
}

export const NumberField: React.FC<NumberFieldProps> = ({ field, onChange }) => {
  return (
    <Field icon={Hash} label={field.label} visibleAt={field.visibleAt}>
      <input
        type="number"
        value={field.value}
        onChange={(e) => onChange(Number(e.target.value))}
        min={field.min}
        max={field.max}
        step={field.step}
        className="w-full h-8 md:h-6 bg-slate-900/50 text-slate-300 md:text-xs px-2 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500"
      />
    </Field>
  );
};
